export const notFound = {
  title: 'Oops! Page not found.',
  description:
    'It seems the page you are looking for does not exist. Check the URL or return to the homepage.',
  backToHome: 'Back to homepage',
  imageAlt: '404 page not found',
};
